import { useFetchBrowserSession } from './useFetchBrowserSession'
import { createQueryComposable } from '../session/queryComposableFactory'

export const useQueryBrowserSession = createQueryComposable(useFetchBrowserSession)
